// This component is not used anywhere //

import React, { useState } from "react";
import PropTypes from "kf-proptypes/widgets";
import { Trans } from "@lingui/macro";

import styles from "./threestateswitch.css";

export function ThreeStateSwitch(props) {
  const { onChange } = props;
  const [value, setValue] = useState("auto");
  function toggle() {
    if (value === "auto") {
      setValue("light");
      onChange("light");
    } else if (value === "light") {
      setValue("dark");
      onChange("dark");
    } else if (value === "dark") {
      setValue("auto");
      onChange("auto");
    }
  }
  return (
    <button className={`${styles.container} ${styles[value]}`} onClick={toggle}>
      <div className={styles.autotext}>
        <Trans>auto</Trans>
      </div>
      <div className={styles.dot} />
      <div className={styles.border} />
    </button>
  );
}

ThreeStateSwitch.propTypes = {
  onChange: PropTypes.func
};
